export const getAddressToQueryId = (walletAddress: string): number => {
  let hash = 0,
    i,
    chr;
  if (walletAddress.length === 0) return hash;

  if (walletAddress.startsWith("0x")) {
    walletAddress = walletAddress.substring(2);
  }

  for (i = 0; i < walletAddress.length; i++) {
    chr = walletAddress.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }

  return Math.abs(hash);
};
